import Decimal from 'decimal.js';

Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP });

// Konvertiert beliebige Eingabe sicher zu Decimal.
// null/undefined/NaN/'' → Decimal(0)
export function D(value) {
  if (value == null || value === '' || (typeof value === 'number' && !isFinite(value))) {
    return new Decimal(0);
  }
  try {
    return new Decimal(value);
  } catch {
    return new Decimal(0);
  }
}

export const D_ZERO    = new Decimal(0);
export const D_EPSILON = new Decimal('1e-9');
export const D_MICRO   = new Decimal('1e-6');

export { Decimal };
